// packages/shared-hooks/src/users/useUser.ts
// Spec §18. GET /users/:id detail fetch keyed as ['user', id].
import { useQuery } from '@tanstack/react-query';
import { UserSchema, type User } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useUser(id: string) {
  const client = useApiClient();
  return useQuery<User>({
    queryKey: ['user', id],
    queryFn: ({ signal }) => client.get<User>(`/users/${id}`, { signal }, UserSchema),
  });
}
